import "../index.css";

import { Route, Routes } from "react-router";
import { GuestRoute } from "@/components/guest-route";
import { AppLayout } from "@/components/layout/app-layout";
import { ObraRedirect } from "@/components/obra-redirect";
import { OnboardingRoute } from "@/components/onboarding-route";
import { ProtectedRoute } from "@/components/protected-route";
import { RequirePermission } from "@/components/require-permission";
import { ConfiguracoesPage } from "@/pages/configuracoes";
import { CanteirosSettingsPage } from "@/pages/configuracoes/canteiros";
import { StageTemplatesPage } from "@/pages/configuracoes/templates";
import { StageTemplateDetailPage } from "@/pages/configuracoes/templates/detalhe";
import { ContaPage } from "@/pages/configuracoes-conta";
import { ConfiguracoesDaObraPage } from "@/pages/configuracoes-da-obra";
import { JornadaPage } from "@/pages/configuracoes-da-obra/jornada";
import { CronogramaPage } from "@/pages/cronograma";
import { DocumentsPage } from "@/pages/documentos";
import { EditarCanteiroPage } from "@/pages/editar-canteiro";
import { EnderecoObraPage } from "@/pages/endereco";
import { EtapasPage } from "@/pages/etapas";
import { EtapaCreatePage } from "@/pages/etapas/adicionar";
import { EtapaEditPage } from "@/pages/etapas/editar";
import { FeedPage } from "@/pages/feed";
import { PostPage } from "@/pages/feed/relato";
import { ForgotPasswordPage } from "@/pages/forgot-password";
import { DashboardPage } from "@/pages/home";
import { InvitePage } from "@/pages/invite";
import { LoginPage } from "@/pages/login";
import { NotFoundPage } from "@/pages/not-found";
import { NovoCanteiroPage } from "@/pages/novo-canteiro";
import { OnboardingPage } from "@/pages/onboarding";
import { PresencePage } from "@/pages/presence";
import { RdoListPage } from "@/pages/rdo";
import { RdoEditorPage } from "@/pages/rdo/editor";
// OK-71: PlaceholderPage hidden until the routes below ship post go-live.
// import { PlaceholderPage } from "@/pages/placeholder";
import { TeamPage } from "@/pages/team";
import { TimesheetPage } from "@/pages/timesheet";
import { VerifyEmailPage } from "@/pages/verify-email";

export const AppRoutes = () => {
	return (
		<Routes>
			<Route element={<GuestRoute />}>
				<Route path="/login" element={<LoginPage />} />
				<Route path="/forgot-password" element={<ForgotPasswordPage />} />
			</Route>
			<Route element={<OnboardingRoute />}>
				<Route path="/onboarding" element={<OnboardingPage />} />
				<Route path="/onboarding/convite/:token" element={<OnboardingPage />} />
			</Route>
			<Route path="/onboarding/verify-email" element={<VerifyEmailPage />} />
			<Route path="/verify-email" element={<VerifyEmailPage />} />
			<Route path="/convite/:token" element={<InvitePage />} />
			<Route element={<ProtectedRoute />}>
				<Route index element={<ObraRedirect />} />
				<Route path="novo-canteiro" element={<NovoCanteiroPage />} />
				<Route element={<RequirePermission permission="worksites:update" />}>
					<Route path="editar-canteiro/:id" element={<EditarCanteiroPage />} />
				</Route>
				<Route path=":obra" element={<AppLayout />}>
					<Route index element={<DashboardPage />} />
					<Route path="feed" element={<FeedPage />} />
					<Route path="feed/:postId" element={<PostPage />} />
					<Route path="etapas" element={<EtapasPage />} />
					<Route path="etapas/adicionar" element={<EtapaCreatePage />} />
					<Route path="etapas/:stageId" element={<EtapaEditPage />} />
					<Route
						element={
							<RequirePermission permission="construction_stage_schedules:view" />
						}
					>
						<Route path="cronograma" element={<CronogramaPage />} />
					</Route>
					<Route
						element={
							<RequirePermission
								permission={["time_entries:clock", "time_entries:list"]}
							/>
						}
					>
						<Route path="presenca" element={<PresencePage />} />
					</Route>
					<Route element={<RequirePermission permission="rdos:list" />}>
						<Route path="rdo" element={<RdoListPage />} />
						<Route path="rdo/:rdoId" element={<RdoEditorPage />} />
					</Route>
					<Route element={<RequirePermission permission="documents:list" />}>
						<Route path="documentos" element={<DocumentsPage />} />
					</Route>
					<Route path="equipe" element={<TeamPage />} />
					<Route
						element={<RequirePermission permission="time_entries:list_team" />}
					>
						<Route path="folha-de-horas" element={<TimesheetPage />} />
					</Route>
					<Route path="endereco" element={<EnderecoObraPage />} />
					<Route
						path="configuracoes-da-obra"
						element={<ConfiguracoesDaObraPage />}
					/>
					<Route
						element={<RequirePermission permission="time_settings:manage" />}
					>
						<Route
							path="configuracoes-da-obra/jornada"
							element={<JornadaPage />}
						/>
					</Route>
					<Route
						element={
							<RequirePermission
								permission={["stage_templates:list", "worksites:list"]}
							/>
						}
					>
						<Route path="configuracoes" element={<ConfiguracoesPage />} />
					</Route>
					<Route
						element={<RequirePermission permission="stage_templates:list" />}
					>
						<Route
							path="configuracoes/templates-de-etapas"
							element={<StageTemplatesPage />}
						/>
						<Route
							path="configuracoes/templates-de-etapas/:templateId"
							element={<StageTemplateDetailPage />}
						/>
					</Route>
					<Route element={<RequirePermission permission="worksites:list" />}>
						<Route
							path="configuracoes/canteiros"
							element={<CanteirosSettingsPage />}
						/>
					</Route>
					<Route path="configuracoes/conta" element={<ContaPage />} />
					{/* OK-71: hidden until these features ship post go-live —
					    commented out so the URLs are unreachable, not just hidden. */}
					{/* <Route
						path="almoxarifado"
						element={<PlaceholderPage title="Almoxarifado" />}
					/>
					<Route
						path="requisicoes"
						element={<PlaceholderPage title="Requisições" />}
					/>
					<Route
						path="financeiro"
						element={<PlaceholderPage title="Financeiro" />}
					/> */}
				</Route>
			</Route>
			<Route path="*" element={<NotFoundPage />} />
		</Routes>
	);
};
